<template>
  <div class="w-full h-full">
    <el-table
      ref="tableRef"
      height="calc(100% - 50px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column label="传感器名称" prop="boxName"></el-table-column>
      <el-table-column label="传感器编码" prop="boxIdentifier">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" width="50">
        <template #default="{ row }">
          <div class="cursor-pointer text-[#00BCC8]" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getTableList()"
      :pager-count="5"
    >
    </el-pagination>

    <!-- 查看详情弹窗 -->
    <DialogViewSensorDetail
      class="w-1200px h-600px"
      :detailData="detailData"
      v-if="showDialogViewDetail"
      @close="showDialogViewDetail = false"
    ></DialogViewSensorDetail>
  </div>
</template>

<script>
import { WizboxListingApi } from '@wiz-api/data-box'
import DialogViewSensorDetail from '../../../../cockpit-huizhou/components/IntelligentPowerGeneration/DialogViewSensorDetail'

const wizboxListingApi = new WizboxListingApi()
export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    DialogViewSensorDetail
  },
  data() {
    return {
      keyWords: '',
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      showDialogViewDetail: false,
      detailData: {},
    }
  },
  methods: {
    async getTableList() {
      const [err, res] = await wizboxListingApi.findAllUsingGET1({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.data
        this.page.total = res.page.pageTotal
      }
    },
    lookDetail(row) {
      this.detailData = row
      this.showDialogViewDetail = true
    },
    closeDig() {
      this.showDialogViewDetail = false
    },
  },
  mounted() {},
  created() {
    this.getTableList()
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}
</style>
